import styled from "styled-components"

import { media } from "src/uikit"

export const Container = styled.section`
  background: linear-gradient(249.71deg, #7785ff -0.91%, #6472ef 102.89%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 600px;
  padding: 0 16px;

  .inner {
    display: flex;
    align-items: center;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    z-index: 2;
    position: relative;
    padding-bottom: 76px;
  }

  .inner.success-body {
    display: flex;
    flex-direction: column;
    min-height: 600px;
    align-items: center;
    justify-content: center;
    padding-top: 64px;

    a,
    button {
      z-index: 3;
    }
  }

  .text {
    z-index: 3;
    text-align: center;
    max-width: 1000px;
    width: 100%;
  }

  .text-container {
    max-width: 560px;
    z-index: 2;
    margin-right: 80px;
  }

  .buttons-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 240px;

    button:first-child {
      margin-bottom: 12px;
    }
  }

  .form-container {
    display: flex;
    align-items: center;
    z-index: 2;
    position: relative;
    max-width: 560px;
    width: 100%;
    position: relative;
    box-shadow: rgba(39, 49, 142, 0.2) 0px 24px 30px -10px;
    background-color: #fff;
    border-radius: 18px;
  }

  .bg-1 {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .bg-2 {
    position: absolute;
    top: 0;
    left: 250px;
  }

  @media (max-width: 1246px) {
    .inner {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .text-container {
      max-width: 688px;
      margin: 0;
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .form-container {
      margin: 0;
    }

    .bg-1 {
      display: none;
    }
  }

  @media ${media.tablet} {
    .bg-2 {
      left: 0;
    }
  }

  @media ${media.mobile} {
    padding-left: 16px;
    padding-right: 16px;

    .bg-2 {
      display: none;
    }

    .inner {
      padding-bottom: 40px;
    }

    .text-container {
      margin-bottom: 0;
    }

    .buttons-container {
      width: 100%;
    }
  }
`
